/**
 * Genera un id opaco, corto y url-safe, para la identidad estable de opciones y valores de
 * variante (y de cualquier otro elemento que necesite identidad independiente del texto que
 * el seller ve/edita).
 *
 * Ver doc/multilanguages_products_cateogires/multi-language-architecture.md §5 (decisión D1):
 * "Identidad de opción/valor = id opaco (nanoid). Inmutable, generado en el front al crear el
 * chip, invisible al seller." El id NUNCA se deriva del texto (evita el bug v2 donde
 * `OptionValue.id = value`, que regeneraba el id al renombrar).
 */
const OPAQUE_ID_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

export function generateOpaqueId(prefix: string = 'id'): string {
  let random = '';
  for (let i = 0; i < 14; i++) {
    random += OPAQUE_ID_CHARS.charAt(Math.floor(Math.random() * OPAQUE_ID_CHARS.length));
  }
  return `${prefix}_${random}`;
}
